import { api } from './api';

export interface CtrAnomaly {
  id: number;
  tenantId: string;
  siteId: number;
  page: string;
  query: string | null;
  country: string | null;
  device: string | null;
  dateFrom: string;
  dateTo: string;
  avgPosition: number;
  actualCtr: number;
  expectedCtr: number;
  ctrGap: number;
  impressions: number;
  clicks: number;
  zScore: number;
  isSignificant: boolean;
  potentialClicks: number;
  opportunityScore: number;
  computedAt: string;
}

export interface CtrAnomalySummary {
  totalAnomalies: number;
  significantAnomalies: number;
}

export const getCtrAnomalies = async (
  siteId: number,
  significant?: boolean,
  limit?: number
): Promise<CtrAnomaly[]> => {
  const params = new URLSearchParams();
  if (significant !== undefined) params.append('significant', String(significant));
  if (limit) params.append('limit', String(limit));
  const qs = params.toString();
  const response = await api.get<CtrAnomaly[]>(
    `/earlystage/sites/${siteId}/ctr-anomalies${qs ? `?${qs}` : ''}`
  );
  return response.data;
};

export const getCtrAnomalySummary = async (siteId: number): Promise<CtrAnomalySummary> => {
  const response = await api.get<CtrAnomalySummary>(
    `/earlystage/sites/${siteId}/ctr-anomalies/summary`
  );
  return response.data;
};
